import React from 'react';
import { ZeroState } from '@citrus/zero-state';

const NoResult = ({ number }) => {
  return (
    <ZeroState
      key={"question-" + number + "-empty-state"}
      automationId={"question-" + number + "-no-response-chart"}
      message="There are no results for this question yet."
      imageUrl="https://devuse2cdn.qa.paylocity.com/citrus/illustrations/survey.svg"
    />
  );
}

export default NoResult;